export default __webpack_public_path__ + "static/media/1.d57ef094.png";